import React from "react";
import surgeonIcon from "../../../assets/images/surgeon.svg";
import { getDecodedToken } from "../../../utils/localStorage";
import { formatPhoneNumber } from "../../../utils/helper";

interface DoctorDetailsProps {
  name: string;
  phoneNumber: string;
}

const DoctorDetails: React.FC<DoctorDetailsProps> = () => {
  const tokenData: any = getDecodedToken();
  const { name, mobileNumber, myT } = tokenData?.user || {};
  const practiceId = myT?.accessCode;

  return (
    <article className="flex flex-col justify-center items-center bg-account-bg">
      <div className="flex flex-col justify-center items-center w-[120px] h-[120px] rounded-[1000px] bg-[#E9E9FA] whitespace-wrap">
        <img
          loading="lazy"
          src={surgeonIcon}
          alt={`Profile picture of ${name}`}
          className="object-contain aspect-square w-[49.4px] h-[70.37px]"
        />
        {/* <div className="flex justify-center items-center bg-indigo-600 rounded-3xl w-[32px] h-[32px] rounded-[76px] border-[2px] border-white ml-[70px]">
          <img
            loading="lazy"
            src={editIcon}
            alt={"edit"}
            className="object-contain aspect-square w-[16px] h-[16px]"
          />
        </div> */}
      </div>
      <header className="flex flex-col justify-center items-center px-2 mt-3">
        <h2 className="text-xl font-semibold leading-snug text-gray-800">
          {name}
        </h2>
        <p className="mt-1.5 text-sm leading-loose text-gray-500">
          {formatPhoneNumber(mobileNumber)}
        </p>
        {!!practiceId && <p className="text-sm leading-loose text-gray-500">
          Practice ID:{" "}
          <span className="font-semibold">{practiceId}</span>
        </p>}
      </header>
    </article>
  );
};

export default DoctorDetails;
